import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-toggle-switch';
import classnames from 'classnames';

import styles from './ToggleSwitch.scss';

export default class ToggleSwitch extends Component {
    static propTypes = {
        isOn: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool
    };

    render() {
        const {isOn, disabled, className, onClick} = this.props;
        const switchClass = classnames(
            styles.switch,
            isOn ? styles.on : '',
            className ? className : '',
            disabled ? styles.disabled : ''
        );

        return (
            <Switch className={switchClass} on={isOn} onClick={onClick} enabled={!disabled}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/ToggleSwitch.js